export const SKIP_SET_NAME_KEY = 'ETHSIGN_NEXT_SKIP_SET_NAME';
export const SKIP_SET_PASSWORD_MANAGER = 'ETHSIGN_NEXT_SKIP_SET_PASSWORD_MANAGER';

export const ENVS = {
  VITE_WALLET_CONNECT_PROJECT_ID: import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID,
  VITE_GRAPHQL_APP_NAME: import.meta.env.VITE_GRAPHQL_APP_NAME,
  VITE_ETHSIGN_SIGN_ADDRESS: import.meta.env.VITE_ETHSIGN_SIGN_ADDRESS,
  VITE_PARTICLE_PROJECT_ID: import.meta.env.VITE_PARTICLE_PROJECT_ID,
  VITE_ALCHEMY_API_KEY: import.meta.env.VITE_ALCHEMY_API_KEY,
  VITE_TELEGRAM_BOT_NAME: import.meta.env.VITE_TELEGRAM_BOT_NAME,
  VITE_PARTICLE_CLIENT_KEY: import.meta.env.VITE_PARTICLE_CLIENT_KEY,
  VITE_PARTICLE_APP_ID: import.meta.env.VITE_PARTICLE_APP_ID,
  VITE_DOCUMENT_URL: import.meta.env.VITE_DOCUMENT_URL,
  get VITE_APP_ENV(): keyof typeof redirectHost {
    const env = import.meta.env.VITE_APP_ENV;
    if (env !== 'production' && env !== 'development') {
      return 'production';
    } else {
      return env;
    }
  }
};

export const TELEGRAM_LOGIN_URL = 'https://ethsign-tg-connect.vercel.app';

export enum EVENT_MESSAGE_NAME_ENUM {
  TELEGRAM_LOGIN_SUCCESS = 'tg-brother:telegram_login',
  SINGPASS_CONNECT_SUCCESS = 'singpass-connect:success',
  UAEPASS_CONNECT_SUCCESS = 'uaepass-connect:success'
}

export const GTAG_ID = 'G-TVX4X4VKBR';

export const SiteConfig = {
  get API_URL(): string {
    return '/api';
  },
  get TELEGRAM_BOT_TOKEN(): string {
    return window.SiteConfig?.TELEGRAM_BOT_TOKEN;
  },
  get ALCHEMY_API_KEY(): string {
    return window.SiteConfig?.ALCHEMY_API_KEY;
  },
  get PARTICLE_PROJECT_ID(): string {
    return window.SiteConfig?.PARTICLE_PROJECT_ID;
  },
  get PARTICLE_CLIENT_KEY(): string {
    return window.SiteConfig?.PARTICLE_CLIENT_KEY;
  },
  get PARTICLE_APP_ID(): string {
    return window.SiteConfig?.PARTICLE_APP_ID;
  },
  get ETHSIGN_SIGN_ADDRESS(): string {
    return window.SiteConfig?.ETHSIGN_SIGN_ADDRESS;
  },
  get GRAPHQL_APP_NAME(): string {
    return window.SiteConfig?.GRAPHQL_APP_NAME;
  }
};
export const SessionKeys = {
  RECIPIENTS: 'RECIPIENTS',
  FILE: 'FILE'
};

export enum SIGN_ROLE_ENUM {
  SIGNER = 'signer',
  VIEWER = 'viewer'
}

export const SIGN_ROLE_DISPLAY = {
  [SIGN_ROLE_ENUM.SIGNER]: 'Signer',
  [SIGN_ROLE_ENUM.VIEWER]: 'Viewer'
};

export const redirectHost = {
  production: 'https://mobile.ethsign.xyz',
  development: 'https://signatures-mobile.dev.ethsign.xyz'
};

export const GlobalConfig = {
  SessionKeyOfDashboardSearch: 'EthSign_Contract_Search_Params'
};

export enum ErrorCode {
  E001 = 'E001'
}
